module.exports = __webpack_public_path__ + "img/torado.3e9d7bd0.jpg";